// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__hywkJ","aparecer":"Login_aparecer__sYJhp","main":"Login_main__KxyVl","branding":"Login_branding__VveVg"};